import React, {useState, useEffect, useRef} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import '../assets/css/buses.css';
import {api} from '../../api';
import BookingForm from "../components/bookingFrom";
import {capitalize} from '../utils/helper';
import {useNotifyHook} from '../hooks/useNotify';
import Loader from '../components/Loader';
import BusDetails from '../components/busDetails';
import BusSidebarDetails from "../components/bussidebardetails"

const Buses = () => {
    const navigate = useNavigate();
    const notify = useNotifyHook();
    const location = useLocation();
    const [buses, setBuses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchParams, setSearchParams] = useState(null);
    const [busDetails, setBusDetails] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});
    const [expandedBusId, setExpandedBusId] = useState(null);
    const [sidebarBusId, setSidebarBusId] = useState(null);
    // Track which bus sidebar is open

    // Fetch buses function (same as before)
    const fetchBuses = async (from, to, fromCity, toCity, typeFrom, typeTo, date) => {
        try {
            setLoading(true);
            const response = await axios.get(api.buses, {
                params: {
                    from,
                    to,
                    fromCity,
                    toCity,
                    typeFrom,
                    typeTo,
                    date
                }
            });

            if (response.data.status && response.data.data) {
                setBuses(response.data.data);
            } else {
                notify.error(response.data.message || 'No buses found');
                setBuses([]);
            }
        } catch (err) {
            console.error('Error fetching buses:', err);
            notify.error('Failed to fetch buses. Please try again.');
            setBuses([]);
        } finally {
            setLoading(false);
        }
    };

    const handleModifySearch = (searchData) => {
        setSearchParams({
            from: searchData.from,
            to: searchData.to,
            fromCity: searchData.fromCity,
            toCity: searchData.toCity,
            typeFrom: searchData.typeFrom,
            typeTo: searchData.typeTo,
            date: searchData.date,
            fromName: searchData.fromName,
            toName: searchData.toName,
            fromData: searchData.fromData,
            toData: searchData.toData
        });

        fetchBuses(searchData.from, searchData.to, searchData.fromCity, searchData.toCity, searchData.typeFrom, searchData.typeTo, searchData.date);
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const from = queryParams.get('from');
        const to = queryParams.get('to');
        const fromCity = queryParams.get('fromCity');
        const toCity = queryParams.get('toCity');
        const typeFrom = queryParams.get('typeFrom');
        const typeTo = queryParams.get('typeTo');
        const date = queryParams.get('date');
        const fromName = queryParams.get('fromName');
        const toName = queryParams.get('toName');

        const fromData = {
            original_name: from,
            displayName: fromName,
            name: fromName,
            city: fromCity,
            pickupDropType: typeFrom
        }

        const toData = {
            original_name: to,
            displayName: toName,
            name: toName,
            city: toCity,
            pickupDropType: typeTo
        }

        if (from && to) {
            setSearchParams({
                from,
                to,
                fromCity,
                toCity,
                typeFrom,
                typeTo,
                date,
                fromName,
                toName,
                fromData,
                toData
            });
            fetchBuses(from, to, fromCity, toCity, typeFrom, typeTo, date);
        } else {
            setError('Search parameters are missing');
            setLoading(false);
        }
    }, [location.search]);

    const formatTime = (timeString) => {
        return timeString ? timeString.slice(0, 5) : '--:--';
    };

    const formatCurrency = (amount) => {
        return `₹${
            parseFloat(amount).toFixed(2)
        }`;
    };
    const renderRatingStars = (rating) => {
        return Array.from({
            length: 5
        }, (_, i) => (
            <span key={i}
                className={
                    i < rating ? "text-[#f97316]" : "text-gray-300"
            }>
                ★
            </span>
        ));
    };


    const getBusDetails = async (busId, fromId, toId, routeId) => {
        try { // If already expanded, close it
            if (expandedBusId === busId) {
                setExpandedBusId(null);
                setSidebarBusId(null);
                return;
            }

            setLoadingDetails(prev => ({
                ...prev,
                [busId]: true
            }));
            const response = await axios.post(api.busDetails, {
                bus_id: busId,
                from_stand_id: fromId,
                to_stand_id: toId,
                route_id: routeId,
                date: searchParams ?. date

            });

            if (response.data.status && response.data.data) {
                const r = response.data;
                if (r.data.bus && r.data.pickupPonit && r.data.dropPonit && r.data.seats) {
                    setBusDetails(prev => ({
                        ...prev,
                        [busId]: {
                            bus: r.data.bus,
                            pickupPoints: r.data.pickupPonit,
                            dropPoints: r.data.dropPonit,
                            seats: r.data.seats,
                            cancelPolicy: r.data.cancelPolicy,
                            coupons: r.data.coupons,
                            fee: r.data.fee,
                            gallery: r.data.gallery,
                            features: r.data.features,
                            reviews: r.data.reviews,
                            isCoupon: r.data.isCoupon
                        }
                    }));
                }
                setExpandedBusId(busId);
            }
        } catch (error) {
            notify.error('Failed to load bus details');
        } finally {
            setLoadingDetails(prev => ({
                ...prev,
                [busId]: false
            }));
        }
    }

    // Open sidebar for specific bus
    const openSidebar = (busId) => {
        setSidebarBusId(busId);
    };

    // Close sidebar
    const closeSidebar = () => {
        setSidebarBusId(null);
    };

    if (loading) {
        return (
            <> {
                searchParams && (
                    <BookingForm date={
                            searchParams ?. date
                        }
                        fromData={
                            searchParams ?. fromData
                        }
                        toData={
                            searchParams ?. toData
                        }
                        modify={true}
                        onModifySearch={handleModifySearch}/>
                )
            }
                <Loader rows={4}
                    height={50}
                    gridColumns={2}
                    center={true}/>
            </>
        );
    }

    if (error && buses.length === 0) {
        return (
            <> {
                searchParams && (
                    <BookingForm date={
                            searchParams ?. date
                        }
                        fromData={
                            searchParams ?. fromData
                        }
                        toData={
                            searchParams ?. toData
                        }
                        modify={true}
                        onModifySearch={handleModifySearch}/>
                )
            }

                <div className="buses-container">
                    <div className="no-results">
                        <div className="bus-icon">🚌</div>
                        <h2>No Buses Found</h2>
                        <p>{error}</p>
                        <button onClick={
                                () => navigate(-1)
                            }
                            className="search-again-btn">
                            Search Again
                        </button>
                    </div>
                </div>
            </>
        );
    }

    return (
        <> {
            searchParams && (
                <BookingForm date={
                        searchParams ?. date
                    }
                    fromData={
                        searchParams ?. fromData
                    }
                    toData={
                        searchParams ?. toData
                    }
                    modify={true}
                    onModifySearch={handleModifySearch}/>
            )
        }

            {/* Render sidebar only when a specific bus is selected */}
            {
            sidebarBusId && busDetails[sidebarBusId] && (
                <BusSidebarDetails bus={
                        busDetails[sidebarBusId].bus
                    }
                    pickup={
                        busDetails[sidebarBusId].pickupPoints
                    }
                    drop={
                        busDetails[sidebarBusId].dropPoints
                    }
                    cancelPolicy={
                        busDetails[sidebarBusId].cancelPolicy
                    }
                    reviews={
                        busDetails[sidebarBusId].reviews
                    }
                    isCoupon={
                        busDetails[sidebarBusId].isCoupon
                    }
                    isOpen={
                        !!sidebarBusId
                    }
                    onClose={closeSidebar}/>
            )
        }

            <div className="buses-container">
                {
                buses.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
                        <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full">
                            <span className="text-4xl">🚌</span>
                        </div>

                        <h3 className="mb-2 text-2xl font-semibold text-gray-900">
                            No Buses Available
                        </h3>

                        <p className="mb-8 max-w-md text-lg text-gray-600">
                            Try adjusting your search criteria
                        </p>

                        <div className="mt-6 max-w-sm text-sm text-gray-500">
                            <p className="mb-1">• Check different date or time</p>
                            <p className="mb-1">• Try alternative routes</p>
                            <p className="">• Verify your pickup location</p>
                        </div>
                    </div>
                ) : (
                    <div className="buses-list container mx-auto grid grid-cols-3 gap-2">
                        <div className="col-span-1 hidden md:block">
                            <div className="bg-white rounded-xl shadow-lg p-6  hover:shadow-xl transition-shadow duration-300">
                                <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-3 border-b border-gray-100">
                                    Buses Summary
                                </h3>

                                <ul className="space-y-4">
                                    {/* Total Buses */}
                                    <li className="flex items-center justify-between p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors duration-200">
                                        <div className="flex items-center">
                                            <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center mr-3">
                                                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                                                </svg>
                                            </div>
                                            <span className="text-gray-600 font-medium">Total Buses</span>
                                        </div>
                                        <span className="text-2xl font-bold text-blue-700">
                                            {
                                            buses.length
                                        }</span>
                                    </li>

                                    {/* AC Buses */}
                                    <li className="flex items-center justify-between p-3 bg-green-50 rounded-lg hover:bg-green-100 transition-colors duration-200">
                                        <div className="flex items-center">
                                            <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center mr-3">
                                                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4 4 0 003 15z"/>
                                                </svg>
                                            </div>
                                            <span className="text-gray-600 font-medium">AC Buses</span>
                                        </div>
                                        <span className="text-2xl font-bold text-green-700">
                                            {
                                            buses.filter(bus => bus.ac == true).length
                                        } </span>
                                    </li>

                                    {/* Non-AC Buses */}
                                    <li className="flex items-center justify-between p-3 bg-amber-50 rounded-lg hover:bg-amber-100 transition-colors duration-200">
                                        <div className="flex items-center">
                                            <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center mr-3">
                                                <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
                                                </svg>
                                            </div>
                                            <span className="text-gray-600 font-medium">Non-AC Buses</span>
                                        </div>
                                        <span className="text-2xl font-bold text-amber-700">
                                            {
                                            buses.filter(bus => bus.ac == false).length
                                        } </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="md:col-span-2 col-span-3">
                            {
                            buses.map((bus) => (
                                <div key={
                                        bus.id || bus.busId || `${
                                            bus.from
                                        }_${
                                            bus.to
                                        }_${
                                            bus.departureTime
                                        }`
                                    }
                                    className="bus-card bg-white rounded-xl shadow-md  mb-4">
                                    <div className="bg-white rounded-xl shadow-lg w-full overflow-hidden">
                                        <div className="p-2">
                                            <div className="flex justify-between items-center mb-4">
                                                <div className="mb-1">
                                                    <h1 className="text-md font-bold">
                                                        {
                                                        bus.vendor.company
                                                    } </h1>
                                                    <p className="text-sm opacity-90 text-gray-500">
                                                        {
                                                        bus.name
                                                    }&nbsp;{
                                                        capitalize(bus.type)
                                                    }&nbsp;{
                                                        bus.ac == true ? 'A/C' : 'Non-A/C'
                                                    }&nbsp;{
                                                        bus.row_data.rows_lower
                                                    } </p>
                                                </div>
                                                <div className="">
                                                    <div className="flex items-center gap-2">
                                                        <div className="flex ">
                                                            {
                                                            renderRatingStars(bus.rating || 0)
                                                        } </div>
                                                        <span className="font-bold text-gray-800">
                                                            {
                                                            bus.rating ? bus.rating.toFixed(1) : '0'
                                                        } </span>
                                                    </div>
                                                    {
                                                    bus.seats && (
                                                        <div className="text-sm text-gray-500 mt-1">
                                                            {
                                                            bus.seats
                                                        }
                                                            &nbsp;Seats {
                                                            bus.single_seat && ` (${
                                                                bus.single_seat
                                                            } Single)`
                                                        } </div>
                                                    )
                                                } </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-md font-semibold">
                                                        {
                                                        formatTime(bus.time.boarding_time)
                                                    }
                                                        - {
                                                        formatTime(bus.time.arrival_time)
                                                    }
                                                        <div className="text-gray-600 text-xs text-center">
                                                            {
                                                            bus.time.total_time
                                                        } </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-md font-bold text-blue-600">
                                                        {
                                                        formatCurrency(bus.fare || bus.price || 750)
                                                    } </div>
                                                    <div className="text-sm text-gray-500">Onwards</div>
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="mt-1">
                                                <div className="text-end flex items-center justify-end">
                                                    {
                                                    expandedBusId === bus.id && busDetails[bus.id] && (
                                                        <div className="text-center">
                                                            <button onClick={
                                                                    () => openSidebar(bus.id)
                                                                }
                                                                className="text-white bg-blue-600 me-2 py-2 box-border border border-transparent font-medium leading-5 rounded-base text-sm px-4 py-2.5 focus:outline-none bg-blue-600 rounded-full"
                                                                type="button">
                                                                Details
                                                            </button>
                                                        </div>
                                                    )
                                                }
                                                    <button disabled={
                                                            loadingDetails[bus.id]
                                                        }
                                                        onClick={
                                                            () => getBusDetails(bus.id, bus.from_stand, bus.to_stand, bus.route_id)
                                                        }
                                                        className="bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-full transition-colors duration-300">
                                                        {
                                                        loadingDetails[bus.id] ? 'Loading...' : expandedBusId === bus.id ? 'Hide Seats' : 'Seats'
                                                    } </button>
                                                </div>

                                                {
                                                expandedBusId === bus.id && busDetails[bus.id] && (
                                                    <BusDetails bus={
                                                            busDetails[bus.id].bus
                                                        }
                                                        pickupPoints={
                                                            busDetails[bus.id].pickupPoints
                                                        }
                                                        dropPoints={
                                                            busDetails[bus.id].dropPoints
                                                        }
                                                        coupons={
                                                            busDetails[bus.id].coupons
                                                        }
                                                        fee={
                                                            busDetails[bus.id].fee
                                                        }
                                                        isCoupon={
                                                            busDetails[bus.id].isCoupon
                                                        }
                                                        seats={
                                                            busDetails[bus.id].seats
                                                        }/>
                                                )
                                            } </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        } </div>
                    </div>
                )
            } </div>
        </>
    );
};

export default Buses;
